import Vue from 'vue'
import axios from 'axios'
import { BACKEND_URL } from '@/constants'

const getAuth = () => {
  const email = Vue.$cookies.get('email')
  const token = Vue.$cookies.get('token')
  return {
    auth: {
      email: email,
      token: token
    }
  }
}

export default {
  resetPassword: ({ password, password_confirmation, token }) => {
    return axios.post(BACKEND_URL + '/auth/password_save', { password, password_confirmation, token });
  },
  login: (email, password) => {
    return axios.post(BACKEND_URL + '/portal/login', { email, password })
  },
  getCompanyLogos: () => {
    return axios.post(BACKEND_URL + '/admin/company-logos', { ...getAuth() })
  },
  updateCompanyLogo: async (company) => {
    let reader = new FileReader()

    let file = null
    if (company.file) {
      file = await new Promise(async resolve => {
        reader.onload = async e => {
          resolve(e.target.result.split(',')[1])
        }
        reader.readAsDataURL(company.file)
      }).catch(e => { throw e })
    }

    return axios.post(BACKEND_URL + '/portal/companies/update-logo', { ...getAuth(), ...company, file })
  },
  getLocations: () => {
    return axios.post(BACKEND_URL + '/portal/locations', { ...getAuth() })
  },
  updateLocation: (location) => {
    return axios.post(BACKEND_URL + '/portal/locations/edit', { ...getAuth(), location })
  },
  getNodes: () => {
    return axios.post(BACKEND_URL + '/portal/nodes', { ...getAuth() })
  },
  getAllNodes: () => {
    return axios.post(BACKEND_URL + '/portal/nodes/getAll', { ...getAuth() })
  },
  getNodesForLocation: (locationId, nodeType) => {
    return axios.post(BACKEND_URL + '/portal/nodes/getTypedForLocation', { ...getAuth(), locationId, nodeType })
  },
  updateNode: (node, type) => {
    return axios.post(BACKEND_URL + '/portal/nodes/edit', { ...getAuth(), data: node, type })
  },
  getCompanies: () => {
    return axios.post(BACKEND_URL + '/portal/companies', { ...getAuth() })
  },
  updateCompany: (company) => {
    return axios.post(BACKEND_URL + '/portal/companies/edit', { ...getAuth(), company })
  },
  generateSpreadsheet: (company) => {
    return axios.post(BACKEND_URL + '/portal/companies/generate_spreadsheet', { ...getAuth(), company })
  },
  createOrder: (nodes, optionSelections, origin) => {
    return axios.post(BACKEND_URL + '/portal/orders/create', { ...getAuth(), nodes, optionSelections, origin })
  },
  getOrderByConfirmation: (confirmationId) => {
    return axios.post(BACKEND_URL + '/portal/orders/getByConfirmation', { ...getAuth(), confirmationId })
  },
  getMobileOrderByConfirmation: (confirmationId) => {
    return axios.post(BACKEND_URL + '/portal/orders/getMobileByConfirmation', { ...getAuth(), confirmationId })
  },
  getOrdersForUser: () => axios.post(BACKEND_URL + '/portal/orders/getForUser', { ...getAuth() }),
  getOrderForUser: (id) => axios.post(BACKEND_URL + '/portal/orders/findForUser', { ...getAuth(), id }),
  getMobileOrder: (uuid) => axios.post(BACKEND_URL + '/portal/orders/findByUuid', { ...getAuth(), uuid }),
  createMobileOrder: (nodes, optionSelections, origin, uuid) => {
    return axios.post(BACKEND_URL + '/portal/orders/create', { ...getAuth(), nodes, optionSelections, origin, source: uuid })
  },

  // Founder web commands
  getPricing: () => {
    return axios.post(BACKEND_URL + '/portal/pricing/get', { ...getAuth() })
  },
  updatePricing: (companyId, priceMap) => {
    return axios.post(BACKEND_URL + '/portal/pricing/update', { companyId, priceMap, ...getAuth() })
  },
  getNodeData: (companyId, type) => {
    return axios.post(BACKEND_URL + '/portal/nodes/getByType', { ...getAuth(), companyId, type })
  },
  getInvoiceData: (companyId) => {
    return axios.post(BACKEND_URL + '/portal/companies/invoice_spreadsheet', { ...getAuth(), companyId })
  },
  getBusinessCategories: () => {
    return axios.post(BACKEND_URL + '/portal/business_categories', { ...getAuth() })
  },
  addBusinessCategory: (name) => {
    return axios.post(BACKEND_URL + '/portal/business_categories/add', { ...getAuth(), name })
  },
  deleteBusinessCategory: (name) => {
    return axios.post(BACKEND_URL + '/portal/business_categories/delete', { ...getAuth(), name })
  },
  getCheckoutOptions: () => axios.post(BACKEND_URL + '/portal/checkout-options', { ...getAuth(), }),
  createCheckoutOption: ({ type, label, perItem, price, nodeTypesJson }) => axios.post(BACKEND_URL + '/portal/checkout-options/create', { ...getAuth(), type, label, perItem, price, nodeTypesJson }),
  editCheckoutOption: ({ id, type, label, perItem, price, nodeTypesJson }) => axios.post(BACKEND_URL + '/portal/checkout-options/edit', { ...getAuth(), id, type, label, perItem, price, nodeTypesJson }),
  deleteCheckoutOption: ({ id }) => axios.post(BACKEND_URL + "/portal/checkout-options/delete", { ...getAuth(), id }),
  getCustomerOrders: () => axios.post(BACKEND_URL + '/portal/orders/', { ...getAuth() }),
  getCustomerOrder: (id) => axios.post(BACKEND_URL + '/portal/orders/find', { ...getAuth(), id }),

  displayLabel: (nodeId) => axios({ url: BACKEND_URL + '/email/founderlabel/' + nodeId, data: { ...getAuth(), }, responseType: 'blob', method: 'post', }),
  displaySchedule: (nodeId) => axios({ url: BACKEND_URL + '/email/founderschedule/' + nodeId, data: { ...getAuth(), }, responseType: 'blob', method: 'post', }),

  setOrderHandled: (orderId, handled) => axios.post(BACKEND_URL + '/portal/orders/handle', { ...getAuth(), orderId, handled }),

  addAdmin: (userData, companyId) => axios.post(BACKEND_URL + '/portal/companies/add-admin', { ...getAuth(), userData, companyId }),

  getArchivedLocations: () => {
    return axios.post(BACKEND_URL + '/portal/locations/archived', { ...getAuth() })
  },
  setArchivedOwner: (locationId, companyId) => {
    return axios.post(BACKEND_URL + '/portal/locations/grant-archived', { ...getAuth(), locationId, companyId, })
  },
}
